/**
 * 后台钱包学习币等转换工具
 */
export default {
	// 传递钱包数据
	toWallet(data) {
		// return parseFloat(data)*100
		return multx(data,100);
	},
	// 格式化后台返回钱包数据
	parseWallet(data) {
		return parseFloat(data)/100
	},
	// 传递后台学习币
	toCoin(data) {
		return parseFloat(data)
	},
	// 格式化后台返回学习币数据
	parseCoin(data) {
		return parseFloat(data)
	},
	// 传递钱包数据（老爱心币）
	toOldWallet(data) {
		// return parseFloat(data)*10
		return multx(data,10);
	},
	// 格式化后台返回钱包数据（老爱心币）
	parseOldWallet(data) {
		return parseFloat(data)/10
	},

	/*财务换算*/
	parseWallet_money(data) {
		return parseFloat(data)/100
	},
	parseCoin_money(data) {
		return parseFloat(data)/100		
	},
	toWallet_money(data) {
		// return parseFloat(data)*100
		return multx(data,100);
	},
	toCoin_money(data) {
		// return parseFloat(data)*100
		return multx(data,100);
	},
	parseCoin(data) {
		// return parseFloat(data)*100
		return parseFloat(data)/10
	}
}

/*
 *处理乘以100后精度丢失问题
 *num: 要处理的数
 *x: 10的倍数
 */
function multx(num,x){
	//数字转字符串
	num = num.toString();
	//判断小数几位
	let digits = num.indexOf('.');
	if(digits != -1){
	digits = num.length - num.indexOf('.')-1;	
	}else{
		digits = 0;
	}
	num = num.replace('.','');
	//判断移动几位
	let move = Math.log10(x);
	//需要补足的位数
	let need0 = move - digits;

	if(need0 >= 0){
		//补足0
		for( let i = 0; i < need0; i++){
			num += '0'
		}
	}else{
		// 补小数点
		num = num.split('')
		num.splice(num.length + need0,0,'.')
		num = num.join('')
		num = parseFloat(num).toString();
	}
	return parseFloat(num);
}


// WEBPACK FOOTER //
// ./src/utils/exchange.js